import React, { FC, useRef, useState } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { dateCalendarFormatType, currentFormatTime, dateFormat } from 'src/utils/dateSet';
import { addComma } from 'src/utils/common';
import NoResult from 'src/components/molecules/table/NoResult';

interface Props {
  data: any;
  viewType?: string;
  modifyItemEvt: (item: any) => void;
  deleteItemEvt: (item: any) => void;
}
const GridList: FC<Props> = ({ data, viewType, modifyItemEvt, deleteItemEvt }) => {
  const viewData: any = data || [];
  const setData = [];
  const deleteEvt = (item: any) => {
    deleteItemEvt(item);
  };
  const modifyEvt = (item: any) => {
    modifyItemEvt(item);
  };

  const viewTerm = (item: any) => {
    let typeView = '';
    switch (item) {
      case '1':
        typeView = '10년이상 15년미만';
        break;
      case '2':
        typeView = '15년이상 30년미만';
        break;
      case '3':
        typeView = '30년 이상';
        break;
      default:
        typeView = '';
        break;
    }
    return typeView;
  };
  const viewMethod = (item: any) => {
    let typeView = '';
    switch (item) {
      case '1':
        typeView = '고정금리 또는 비거치식분할상환';
        break;
      case '2':
        typeView = '고정금리 이면서 비거치식분할상환';
        break;
      case '3':
        typeView = '기타 대출';
        break;
      default:
        typeView = '';
        break;
    }
    return typeView;
  };
  return (
    <div className="_table_grid_layout _housesave_list_grid">
      <div className="_grid">
        <div className="_label">
          <div className="_row _i_h3">
            {viewType === 'modify' ? (
              <>
                <div className="_col _wd_n01 _hd_n01">
                  <div className="_tit"></div>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="_col _wd_n4">
              <div className="_cont">국세청 자료</div>
            </div>
            <div className="_col _wd_n2">
              <div className="_cont">차입일</div>
            </div>
            <div className="_col _wd_n2">
              <div className="_cont">금액(국세청)</div>
            </div>
            <div className="_col _wd_n2">
              <div className="_cont">금액(일반)</div>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div className="_content">
          {viewData.map((item: any, idx: number) => {
            const infoData = item || {};

            return (
              <div className="_row _i_h2" key={idx}>
                {viewType === 'modify' ? (
                  <>
                    <div className="_col _wd_n01">
                      <div className="_cont">
                        <div className="_i_row ">
                          <div className="_i_col _w_p_50  _bor_r">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => modifyEvt(item)}
                                icon="ri-edit-box-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                          <div className="_i_col _w_p_50">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => deleteEvt(item)}
                                icon="ri-delete-bin-2-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                <div className="_col _wd_n4">
                  <div className="_cont">{infoData.is_htx_pdf === 'Y' ? '국세청제공' : '-'}</div>
                </div>
                <div className="_col _wd_n2">
                  <div className="_cont">{dateFormat(infoData.loan_date, 'YYYY.MM.DD')}</div>
                </div>
                <div className="_col _wd_n2">
                  <div className="_cont">{addComma(infoData.htx_amt)}</div>
                </div>
                <div className="_col _wd_n2">
                  <div className="_cont">{addComma(infoData.amt)}</div>
                </div>
              </div>
            );
          })}
          {viewData.length === 0 ? <NoResult /> : ''}
        </div>
      </div>
    </div>
  );
};

export default GridList;
